import React, { useEffect, useState, useRef } from 'react';
import { VideoCamera, ArrowRight } from '@phosphor-icons/react';
export function CTASection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="bg-black text-white py-20 sm:py-24 md:py-32 px-6 sm:px-12 md:px-16 lg:px-24" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
    transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
  }} data-id="element-1695">
      <div className="max-w-4xl mx-auto text-center" data-id="element-1696">
        <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl mb-8 sm:mb-10 md:mb-12 uppercase leading-tight" style={{
        fontFamily: "'Gefika', sans-serif",
        fontWeight: 400,
        letterSpacing: '0.02em'
      }} data-id="element-1697">
          Have a Project?
        </h2>
        <a href="https://calendly.com/mateo-cohen9/15min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-white text-black px-8 py-4 rounded-md text-base sm:text-lg font-medium uppercase tracking-wider hover:bg-gray-100 transition-all duration-300 group" style={{
        fontFamily: "'Ronzino', sans-serif",
        letterSpacing: '0.1em'
      }} data-id="element-1698">
          <VideoCamera className="w-5 h-5" data-id="element-1699" />
          <span data-id="element-1700">Book a Call</span>
          <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-1701" />
        </a>
      </div>
    </section>;
}